export default {
  getUserList: "BackEnd/getUserList",

  getQuestionnaireData1List: "BackEnd/getQuestionnaireData1List",
  getQuestionnaireData1Details: "BackEnd/getQuestionnaireData1Details",
  getQuestionnaireData2List: "BackEnd/getQuestionnaireData2List",
  getQuestionnaireData2Details: "BackEnd/getQuestionnaireData2Details",
  getQuestionnaireData3List: "BackEnd/getQuestionnaireData3List",
  getQuestionnaireData3Details: "BackEnd/getQuestionnaireData3Details",
};
